import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {Component, Inject, OnInit} from "@angular/core";


@Component({
    selector: 'changeBusinessDialog',
    templateUrl: 'changeBusiness.dialog.html',
})
export class ChangeBusinessDialog implements OnInit {
    businesses = [
        {name: 'Capitão Bar', cnpj: 1234551233, currency: 'BRL', theme: 'alt-dark-theme', language: 'pt', token: '123', LogoUrl: 'http://capitao.bar/wp-content/uploads/2016/10/Logo-fonte-preta.png'},
        {name: 'Sushi Hokai', cnpj: 87654321, currency: 'BRL', theme: 'dark-theme', language: 'pt', token: '456', LogoUrl: 'http://sushihokkai.com.br/media/wysiwyg/sushi_hokkai_footer.png'},
        {name: 'Mr. Perez', cnpj: 12345623-1, currency: 'PYG', theme: 'default-theme', language: 'es', token: '789', LogoUrl: 'https://guia-paraguai-media.s3.amazonaws.com/media/bar-mr-perez/logo/Sem_t%C3%ADtulo.png'},
    ];

    constructor(public dialogRef: MatDialogRef<ChangeBusinessDialog>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {

    }

    selectBusiness(business){

        this.dialogRef.close(business)
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onConfirm() {
    }

}






// WEBPACK FOOTER //
// ./src/app/sidebar/dialogs/changeBusiness.dialog.ts